<template v-if="components">
  <div>
    <template v-for="(component, index) in components">
      <Attend v-if="component.acf_fc_layout === 'attend' && component.location === location" :data="component" :key="`attend-${index}`" />
      <Discover v-if="component.acf_fc_layout === 'discover' && component.location === location" :data="component" :key="`discover-${index}`" />
      <Newsletter v-if="component.acf_fc_layout === 'newsletter' && component.location === location" :data="component" :key="`newsletter-${index}`" />
      <PageIntro v-if="component.acf_fc_layout === 'page_intro' && component.location === location" :data="component" :key="`page_intro-${index}`" />
      <Supporters v-if="component.acf_fc_layout === 'supporters' && component.location === location" :data="component" :key="`supporters-${index}`" />
      <Columns v-if="component.acf_fc_layout === 'columns' && component.location === location" :data="component" :key="`columns-${index}`" />

      <div class="page-container" v-if="component.acf_fc_layout === 'image_copy_block' && component.location === location" :key="`-${index}`">
        <ImageCopyBlock :data="component" />
      </div>
    </template>
  </div>
</template>

<script>
import Attend from '../components/Attend.vue';
import Discover from '../components/Discover.vue';
import ImageCopyBlock from '../components/ImageCopyBlock';
import Newsletter from '../components/Newsletter.vue';
import PageIntro from '../components/PageIntro';
import Supporters from '../components/Supporters';
import Columns from '../components/Columns';

export default {
  props: ['components', 'location'],
  components: {Attend, Discover, ImageCopyBlock, Newsletter, PageIntro, Supporters, Columns},
  mounted() {
  },
  methods: {
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Components.vue